import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { eotsBaseRoute } from '@app/eots/constants/eots.constants';
import { NavigationData } from '@smooved/core';
import { Navigation } from '@app/navigation/enums/navigation.enum';
import {
    otsContractContactDetailsRoute,
    otsContractMoveDetailsRoute,
    otsContractPaymentDetailsRoute,
    otsContractRoute,
    otsOtherServicesRoute,
    otsSuccessRoute,
} from '@app/ots/constants/ots.constants';
import { ContactDetailsContainer } from '@app/ots/containers/contact-details/contact-details.container';
import { ContractContainer } from '@app/ots/containers/contract-container/contract-container.container';
import { MoveDetailsContainer } from '@app/ots/containers/move-details/move-details.container';
import { OtherServicesContainer } from '@app/ots/containers/other-services/other-services.container';
import { OtsContainerContainer } from '@app/ots/containers/ots-container/ots-container.container';
import { PaymentDetailsContainer } from '@app/ots/containers/payment-details/payment-details.container';
import { SuccessContainer } from '@app/ots/containers/success/success.container';

const routes: Routes = [
    {
        path: '',
        component: OtsContainerContainer,
        children: [
            {
                path: eotsBaseRoute,
                data: {
                    [NavigationData.CoBranding]: true,
                },
                loadChildren: () => import('../eots/eots.module').then((m) => m.EotsModule),
            },
            {
                path: otsContractRoute,
                component: ContractContainer,
                children: [
                    {
                        path: otsContractMoveDetailsRoute,
                        component: MoveDetailsContainer,
                    },
                    {
                        path: otsContractContactDetailsRoute,
                        component: ContactDetailsContainer,
                    },
                    {
                        path: otsContractPaymentDetailsRoute,
                        component: PaymentDetailsContainer,
                    },
                    {
                        path: '**',
                        redirectTo: otsContractMoveDetailsRoute,
                        pathMatch: 'full',
                    },
                ],
            },
            {
                path: otsOtherServicesRoute,
                component: OtherServicesContainer,
            },
            {
                path: otsSuccessRoute,
                component: SuccessContainer,
            },
            {
                path: Navigation.Tots,
                loadChildren: () => import('../tots/tots.module').then((m) => m.TotsModule),
                data: { preload: true },
            },
            {
                path: Navigation.LeaverDetails,
                loadChildren: () => import('../move/wizards/leaver-details/leaver-details.module').then((m) => m.LeaverDetailsModule),
            },
            {
                path: '**',
                redirectTo: 'eots',
                pathMatch: 'full',
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class OtsRoutingModule {}
